import { Link as MuiLink, Stack, Typography } from "@mui/material";
import { ShippingDocumentKind } from "generated-graphql/graphql";

import { UploadableShippingKind } from "../Manifests/ShippingRecordUploadFlow";

/**
 * The way out when the document is not in the picker's list.
 *
 * Each link names what happens next rather than only "upload": a manifest is
 * parsed first, a bill of lading is read and then confirmed by the reviewer,
 * and either way the reader would otherwise guess whether they are done.
 */
export function UploadFallback({
  onUpload,
  canUploadBillOfLading,
}: {
  onUpload: (kind: UploadableShippingKind) => void;
  canUploadBillOfLading: boolean;
}) {
  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        Not here?{" "}
        <MuiLink
          component="button"
          type="button"
          onClick={() => onUpload(ShippingDocumentKind.Manifest)}
        >
          Upload the vendor&apos;s manifest
        </MuiLink>
        . Encamp parses it first, then it appears in this list to link.
      </Typography>
      {canUploadBillOfLading && (
        <Typography variant="body2" color="text.secondary">
          <MuiLink
            component="button"
            type="button"
            onClick={() => onUpload(ShippingDocumentKind.BillOfLading)}
          >
            Upload a bill of lading
          </MuiLink>
          . Encamp reads it, you confirm it, then it appears in this list to link.
        </Typography>
      )}
    </Stack>
  );
}
